<template>
    <div>
        <div class="row model-list">
            <div v-for="item in items" :class="'col-lg-'+colLg">
                <div class="card blog mb-4">
                    <blog-post-card
                        :key="item.id"
                        :blogpost="item"
                        :public-url="item.publicUrl"
                        :tags="item.tags"
                    >
                    </blog-post-card>
                </div>
            </div>
        </div>
        <div class="col">
            <button v-if="showMoreButton" :disabled="loading" @click="loadMore" type="button" class="btn btn-primary btn-lg btn-block my-5">
                Még több cikk
            </button>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {namespace} from 'vuex-class';

  const blogModule = namespace('blog');

  @Component
  export default class BlogPostList extends Vue {

    @Prop(Number) colLg;
    @Prop(Number) perPage;
    @Prop(String) url;

    @blogModule.Getter('getPagination') pagination;
    @blogModule.Getter('isLoading') loading;
    @blogModule.Getter('getItems') items;
    @blogModule.Action('fetchAllAppend') fetchAllAppend;
    @blogModule.Mutation('setUrl') setUrl;
    @blogModule.Mutation('setPagination') setPagination;
    @blogModule.Action('paginatingAppend') paginatingAppend;

    showMoreButton = true;

    created() {

      this.setUrl(this.url);

      this.setPagination({
        perPage: this.perPage,
        currentPage: 1,
        total: 0
      });

      this.fetchAllAppend().then(() => {
        if (this.pagination.total <= this.pagination.perPage) {
          this.showMoreButton = false;
        }
      });
    }

    loadMore() {
      this.paginatingAppend(this.pagination.currentPage + 1);

      if (this.pagination.currentPage * this.pagination.perPage > this.pagination.total) {
        this.showMoreButton = false;
      }
    }
  }
</script>